import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import ImmutableRenderMixin from 'react-immutable-render-mixin';
import urlParser from 'url-parse';
import fetch from 'utils/fetch';
import Dropzone from 'react-dropzone-component';
import classnames from 'classnames';
import formEncode from 'form-urlencoded';
import DropzoneComponentMixin from '../mixins/DropzoneComponentMixin';

export default createReactClass({
  propTypes: {
    options: PropTypes.array,
    error: PropTypes.string,
    uploadLabel: PropTypes.string,
    helpMessage: PropTypes.string,
    onTemporaryDestinationCreated: PropTypes.func,
    onBucketPolicyFailure: PropTypes.func,
  },

  mixins: [ImmutableRenderMixin, DropzoneComponentMixin],

  getDefaultProps() {
    return {
      error: null,
      uploadLabel: 'Upload',
      helpMessage: 'Help',
    };
  },

  handleDropzoneAccept(dropzone, file, done) {
    const dropzoneElement = document.querySelector('.dropzone');

    dropzoneElement.classList.add('dz-max-files-reached');

    const extension = file.name.split('.').pop();
    const options = {
      method: 'POST',
      body: formEncode({
        extension,
        content_type: file.type,
        size: file.size,
      }),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
    };
    const prepareFile = (representation) => {
      const attributes = representation.data.attributes;
      const parsedUrl = urlParser(attributes.url, true);
      const bucket = parsedUrl.host.split('.')[0];
      const imageUrl = `https://s3.amazonaws.com/${bucket}/${attributes['form-data'].key}`;

      /* eslint-disable no-param-reassign */
      dropzone.options.url = attributes.url;
      file.bucketPolicy = attributes['form-data'];
      /* eslint-enable no-param-reassign */

      this.props.onTemporaryDestinationCreated(imageUrl);

      done();
    };
    const bucketFailure = () => {
      this.props.onBucketPolicyFailure();
      this.state.dropzone.removeFile(file);
    };

    fetch('/api/bucket-policies', options)
      .then((response) => {
        if (response.status === 200) {
          response.json().then(prepareFile);
        } else {
          bucketFailure();
        }
      })
      .catch((error) => {
        bucketFailure();
      });
  },

  handleDropzoneSending(file, xhr, formData) {
    Object.keys(file.bucketPolicy).forEach((key) => {
      formData.append(key, file.bucketPolicy[key]);
    });
  },

  handleDropzoneComplete(file) {
    file.complete = true;
  },

  render() {
    const {error} = this.props;
    const {eventHandlers, djsConfig} = this.dropzoneProps(
      {},
      {
        accept: (file, done) => {
          this.handleDropzoneAccept(this.state.dropzone, file, done);
        },
        sending: this.handleDropzoneSending,
        complete: this.handleDropzoneComplete,
      }
    );
    const config = {
      showFiletypeIcon: true,
    };
    return (
      <div>
        <Dropzone config={config} eventHandlers={eventHandlers} djsConfig={djsConfig}>
          <div className="dz-message">
            <i className="ficon ficon-plus-circle"></i>
            <strong>Drop your image here or click to upload one.</strong>
            <p className="m-xs-t-xs m-xs-b-0">We <i className="ficon ficon-heart"></i> JPG, PNG, and SVG files.</p>
          </div>
        </Dropzone>
        {(error) ? <span className="text-help text-muted p-xs-t-xs">{error}</span> : null}
      </div>
    );
  },
});



// WEBPACK FOOTER //
// ./app/javascript/views/Kits/components/DirectToCloudDropzone.js